import { settingsEditComponent } from "./settings-edit.component";
import bootstrapTabs from "angular-ui-bootstrap/src/tabs";
import "./settings-edit.scss";

export const settingsEdit = angular
  .module("components.settings.settingsEdit", [bootstrapTabs])
  .component("settingsEdit", settingsEditComponent)
  .config(($stateProvider) => {
    "ngInject";

    $stateProvider.state("settingsEdit", {
      parent: "app",
      url: "/settings-edit",
      params: {
        settingName: null,
      },
      breadcrumbName: "edit",
      parentState: "settings",
      component: "settingsEdit",
      resolve: {
        details(SettingsService) {
          "ngInject";
          return SettingsService.getSettings().then(({ details }) => details);
        },
      },
    });
  }).name;



// WEBPACK FOOTER //
// ./src/app/components/settings/settings-edit/settings-edit.module.js